// extracted by mini-css-extract-plugin
export var option = "_as-0";
export var optionCard = "_as-f";
export var optionContent = "_as-g";
export var optionIcon = "_as-i";
export var optionIconBox = "_as-h";
export var optionLabel = "_as-j";
export var optionPill = "_as-m";
export var optionPillBadge = "_as-p";
export var optionPillIcon = "_as-n";
export var optionPillLabel = "_as-o";
export var optionRadio = "_as-k";
export var optionRadioInner = "_as-l";
export var optionReveal = "_as-2";
export var optionRevealDelay0 = "_as-3";
export var optionRevealDelay1 = "_as-4";
export var optionRevealDelay10 = "_as-d";
export var optionRevealDelay11 = "_as-e";
export var optionRevealDelay2 = "_as-5";
export var optionRevealDelay3 = "_as-6";
export var optionRevealDelay4 = "_as-7";
export var optionRevealDelay5 = "_as-8";
export var optionRevealDelay6 = "_as-9";
export var optionRevealDelay7 = "_as-a";
export var optionRevealDelay8 = "_as-b";
export var optionRevealDelay9 = "_as-c";
export var optionSelected = "_as-1";